<div style="padding: 1%">
  <div>
    <i nz-icon nzType="arrow-left"  class="trigger" nzTheme="outline" (click)="onBack()" style="margin-left: 10px;"></i>
  </div>
  <h1>Compose new email</h1>
  <nz-divider></nz-divider>
  <form nz-form [formGroup]="newEmail" (ngSubmit)="SendMessage()">
    <nz-form-item>
      <nz-form-label [nzSm]="6" [nzXs]="24" [nzLg]="1" nzFor="to_usercode"
        >Internal</nz-form-label
      >
      <nz-form-control [nzSm]="14" [nzXs]="24">
        <nz-select nzShowSearch nzAllowClear formControlName="to_usercode">
          <nz-option *ngFor="let internal of internals" nzLabel="{{internal.U_NAME}} <{{internal.USER_CODE}}>" nzValue="{{internal.USER_CODE}}"></nz-option>

        </nz-select>
      </nz-form-control>
    </nz-form-item>


    <nz-form-item>
      <nz-form-label [nzSm]="6" [nzXs]="24" [nzLg]="1" nzFor="to"
        >To</nz-form-label
      >
      <nz-form-control [nzSm]="14" [nzXs]="24">
        <nz-select nzMode="tags"  formControlName="to">
          <nz-option *ngFor="let email of Emails" [nzLabel]="email.text" [nzValue]="email.id"></nz-option>
        </nz-select>
        <a class="sideLink" (click)="ifCC=true">CC</a>
      </nz-form-control>
    </nz-form-item>


    <nz-form-item *ngIf="ifCC">
      <nz-form-label [nzSm]="6" [nzXs]="24" [nzLg]="1" nzFor="cc"
        >cc</nz-form-label
      >
      <nz-form-control [nzSm]="14" [nzXs]="24">
        <nz-select nzMode="tags"  formControlName="cc">
          <nz-option *ngFor="let email of Emails" [nzLabel]="email.text" [nzValue]="email.id"></nz-option>
        </nz-select>
        <a class="sideLink" (click)="ifBcc=true">BCC</a>
      </nz-form-control>
    </nz-form-item>


    <nz-form-item *ngIf="ifBcc">
      <nz-form-label [nzSm]="6" [nzXs]="24" [nzLg]="1" nzFor="bcc"
        >Bcc</nz-form-label
      >
      <nz-form-control [nzSm]="14" [nzXs]="24">
        <nz-select nzMode="tags"  formControlName="bcc">
          <nz-option *ngFor="let email of Emails" [nzLabel]="email.text" [nzValue]="email.id"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>


    <nz-form-item>
      <nz-form-label [nzSm]="6" [nzXs]="24" [nzLg]="1" nzFor="subject">
        Subject
      </nz-form-label>
      <nz-form-control [nzSm]="14" [nzXs]="24">
        <input nz-input formControlName="subject" id="subject" />
      </nz-form-control>
    </nz-form-item>


    <nz-form-item>
      <nz-form-label [nzSm]="6" [nzXs]="24" [nzLg]="1" nzFor="body"
        >Body</nz-form-label
      >
      <nz-form-control [nzSm]="14" [nzXs]="24">
        <div [ngxSummernote]="config" formControlName="body"></div>
      </nz-form-control>
    </nz-form-item>
    <div style="width: 100%; text-align: center;">
    <button nz-button nzType="primary" [nzLoading]="loading" type="submit"><i class="far fa-paper-plane" style="margin-right: 3px;"></i> Send</button>
  </div>
  </form>
</div>
